import { createSelector } from 'reselect';

const selectGlobalDodAgencyMapping = (state: any) => state.GlobalDodAgencyMapping;


export const selectGlobalDodAgencyMappingCurrentItem = createSelector([selectGlobalDodAgencyMapping], (GlobalDodAgencyMapping) => GlobalDodAgencyMapping.current);

export const selectGlobalDodAgencyMappingListItems = createSelector([selectGlobalDodAgencyMapping], (GlobalDodAgencyMapping) => GlobalDodAgencyMapping.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectGlobalDodAgencyMappingListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalDodAgencyMappingQueryItems = createSelector([selectGlobalDodAgencyMapping], (GlobalDodAgencyMapping) => GlobalDodAgencyMapping.query);

export const selectGlobalDodAgencyMappingCreatedItem = createSelector([selectGlobalDodAgencyMapping], (GlobalDodAgencyMapping) => GlobalDodAgencyMapping.create);

export const selectGlobalDodAgencyMappingUpdatedItem = createSelector([selectGlobalDodAgencyMapping], (GlobalDodAgencyMapping) => GlobalDodAgencyMapping.update);

export const selectGlobalDodAgencyMappingReadItem = createSelector([selectGlobalDodAgencyMapping], (GlobalDodAgencyMapping) => GlobalDodAgencyMapping.read);

export const selectGlobalDodAgencyMappingDeletedItem = createSelector([selectGlobalDodAgencyMapping], (GlobalDodAgencyMapping) => GlobalDodAgencyMapping.delete);

export const selectGlobalDodAgencyMappingSearchedItems = createSelector([selectGlobalDodAgencyMapping], (GlobalDodAgencyMapping) => GlobalDodAgencyMapping.search);

export const selectGlobalDodAgencyMappingItemsCount = createSelector([selectGlobalDodAgencyMapping], (GlobalDodAgencyMapping) => GlobalDodAgencyMapping.count);

export const selectGlobalDodAgencyMappingItemsFilter = createSelector([selectGlobalDodAgencyMapping], (GlobalDodAgencyMapping) => GlobalDodAgencyMapping.filter);